export const BRANDS = {
  RAFFLES: 'RAF',
  FAIRMONT: 'FAI',
  SOFITEL: 'SOF',
  SOFITELSOS: 'SOS'
}

export const LUXURY_BRANDS = [BRANDS.RAFFLES, BRANDS.FAIRMONT, BRANDS.SOFITEL, BRANDS.SOFITELSOS]
export const isLuxuryBrand = (brand) => LUXURY_BRANDS.includes(brand)

export const WHITE_LABEL_BRANDS = {
  ADAGIO_CITY: 'adagio-city',
  AIRFRANCE: 'airfrance',
  THALASSA: 'thalassa',
  GRAND_MERCURE: 'grandmercure',
  THE_SEBEL: 'thesebel',
  MAMASHELTER: 'mamashelter',
  AH_ARENA: 'accorhotelsarena',
  ACCOR_PLUS: 'accorplus',
  FAIRMONT: 'fairmont',
  SWISSOTEL: 'swissotel',
  RAFFLES: 'raffles'
}

export const FRS_BRANDS = [
  WHITE_LABEL_BRANDS.FAIRMONT,
  WHITE_LABEL_BRANDS.RAFFLES,
  WHITE_LABEL_BRANDS.SWISSOTEL
]
export const ALL_WHITE_LABELS_BRANDS = [
  WHITE_LABEL_BRANDS.ACCOR_PLUS,
  WHITE_LABEL_BRANDS.ADAGIO_CITY,
  WHITE_LABEL_BRANDS.AIRFRANCE,
  WHITE_LABEL_BRANDS.AH_ARENA,
  WHITE_LABEL_BRANDS.FAIRMONT,
  WHITE_LABEL_BRANDS.GRAND_MERCURE,
  WHITE_LABEL_BRANDS.MAMASHELTER,
  WHITE_LABEL_BRANDS.RAFFLES,
  WHITE_LABEL_BRANDS.SWISSOTEL,
  WHITE_LABEL_BRANDS.THALASSA,
  WHITE_LABEL_BRANDS.THE_SEBEL
]

const getBrand = (brands) => {
  for (const brand of brands) {
    if (window.location.origin.includes(brand)) {
      return brand
    }
  }

  return null
}
export const IS_FRS = getBrand(FRS_BRANDS) != null
export const WHITE_LABEL_BRAND = getBrand(ALL_WHITE_LABELS_BRANDS)
export const IS_WHITE_LABEL_BRAND = WHITE_LABEL_BRAND != null
